import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Div from '../Div';
import './portfolio.scss';
import { localizePath } from '../../helper/localizedPath';

export default function Portfolio({ href, src, title, subtitle, variant }) {
  const { i18n } = useTranslation();
  
  return (
    <Link
      to={localizePath(href, i18n.language === 'en' ? 'en' : 'cs')}
      className={`cs-portfolio cs-bg ${variant ? variant : 'cs-style1'}`}
    >
      <>
        <Div className="cs-portfolio_hover" />
        <Div
          className="cs-portfolio_bg cs-bg"
          style={{ backgroundImage: `url("${src}")`}}
        />
        <Div className="cs-portfolio_info">
          <Div className="cs-portfolio_info_bg cs-accent_bg" />
          <h2 className="cs-portfolio_title">{title}</h2>
          <Div className="cs-portfolio_subtitle">{subtitle}</Div>
        </Div>
      </>
    </Link>
  );
}
